import React from 'react'
import styled from 'styled-components';

const BodyStyle = styled.div`
  padding: 40px 0;
  font-size: 28px;
  text-align: center;
  color: #333333;
`;

export default function ModelBody(props) {
  return (
    <BodyStyle>
      {props.children}
    </BodyStyle>
  )
}
